<mat-card appearance="outlined" style="display: flex; flex: 1">
	<app-vinavon-button>
		<button (click)="makeChecklist()" [disabled]="!(canHaveCheckList$ | async)" mat-raised-button>
			<mat-icon>note_add</mat-icon>
			{{ "Checkliste erstellen" }}
		</button>
	</app-vinavon-button>


	<div  [style]="{'display': (hasSADokus$ | async) ? 'block': 'none'}" class="mat-elevation-z8" style="overflow-y: auto">
		<table [dataSource]="dataSourceServiceAppDokus" class="mat-elevation-z8" mat-table>
			<!-- Art Column -->
			<ng-container matColumnDef="doku_art">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_SERVICE_APP.art" | translate }}
				</th>
				<td *matCellDef="let element" mat-cell style="cursor:pointer">
					<img (click)="openDocument(element)" alt="icon" src="/assets/obj_activity_icons/{{ element.imageFile }}"/>
				</td>
			</ng-container>

			<!-- Beschreibung Column -->
			<ng-container matColumnDef="doku_desc">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_SERVICE_APP.beschreibung" | translate }}
				</th>
				<td (click)="openDocument(element)" *matCellDef="let element" mat-cell style="cursor:pointer">
					{{ element.description }}
				</td>
			</ng-container>

			<!-- Dateiname Column -->
			<ng-container matColumnDef="doku_filename">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_SERVICE_APP.dateiname" | translate }}
				</th>
				<td (click)="openDocument(element)" *matCellDef="let element" mat-cell style="cursor:pointer">
					{{ element.documentName }}
				</td>
			</ng-container>

			<!-- Erstell-Datum Column -->
			<ng-container matColumnDef="doku_bearbeitet">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_SERVICE_APP.erstelltAm" | translate }}
				</th>
				<td (click)="openDocument(element)" *matCellDef="let element" mat-cell style="cursor:pointer">
					{{ formatDate(element.datum) }}
				</td>
			</ng-container>

			<!-- Erstellt durch Column -->
			<ng-container matColumnDef="doku_creator">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_SERVICE_APP.erstelltVon" | translate }}
				</th>
				<td (click)="openDocument(element)" *matCellDef="let element" mat-cell style="cursor:pointer">{{ element.creator }}</td>
			</ng-container>

			<!-- Name Column -->
			<ng-container matColumnDef="doku_name">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_SERVICE_APP.name" | translate }}
				</th>
				<td (click)="openDocument(element)" *matCellDef="let element" mat-cell style="cursor:pointer">{{ element.lastName }}</td>
			</ng-container>

			<!-- Vorname Column -->
			<ng-container matColumnDef="doku_vorname">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_SERVICE_APP.vorname" | translate }}
				</th>
				<td (click)="openDocument(element)" *matCellDef="let element" mat-cell style="cursor:pointer">{{ element.firstName }} {{ element.ansprechName }}</td>
			</ng-container>

			<!-- Ansprechname Column -->
			<ng-container matColumnDef="doku_ansprechname">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_SERVICE_APP.ansprechname" | translate }}
				</th>
				<td (click)="openDocument(element)" *matCellDef="let element" mat-cell style="cursor:pointer">
					{{ element.ansprechName }} {{ element.ansprechVorname }}
				</td>
			</ng-container>

			<!-- Ansprechvorname Column -->
			<ng-container matColumnDef="doku_ansprechvorname">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_SERVICE_APP.ansprechvorname" | translate }}
				</th>
				<td (click)="openDocument(element)" *matCellDef="let element" mat-cell style="cursor:pointer">
					{{ element.ansprechVorname }}
				</td>
			</ng-container>

			<!-- Settings Menu Column -->
			<ng-container matColumnDef="doku_settings">
				<th *matHeaderCellDef mat-header-cell style="text-align: center"></th>
				<td *matCellDef="let element" mat-cell style="text-align: center">
					<button [matMenuTriggerFor]="anpaMenu" aria-label="Example icon-button with a menu" mat-icon-button>
						<mat-icon>more_horiz</mat-icon>
					</button>
					<mat-menu #anpaMenu="matMenu">
						<button (click)="openDocument(element)" mat-menu-item>
							<mat-icon>visibility</mat-icon>
							<span>{{ "MAIN_APP_SERVICE_APP.anzeigen" | translate }}</span>
						</button>

							<button (click)="downloadDocument(element)" mat-menu-item>
								<mat-icon>file_download</mat-icon>
								<span>{{ "MAIN_APP_SERVICE_APP.download" | translate }}</span>
							</button>
						<ng-container *ngIf="isVinaIntern">
							<button (click)="deleteDoku(element, $event)" mat-menu-item>
								<mat-icon>delete_forever</mat-icon>
								<span>{{ "MAIN_APP_SERVICE_APP.löschen" | translate }}</span>
							</button>
						</ng-container>
					</mat-menu>
				</td>
			</ng-container>

			<tr *matHeaderRowDef="displayedDokuColumns" mat-header-row></tr>
			<tr *matRowDef="let row; columns: displayedDokuColumns" [ngClass]="{ highlight: selectedDocumentID == row.ID }" mat-row></tr>
		</table>
	</div>

</mat-card>
